import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

// 모바일 판정 훅.
// [코드근거] ui.mode를 세팅하는 setScale은 HomePage.jsx(useEffect의
// updateScale + resize/orientationchange 리스너)에서만 dispatch된다.
// ReviewPage/PreviewPage는 세션 URL로 HomePage를 거치지 않고 직접 진입할 수
// 있어, 그 경우 아이폰/안드로이드에서도 mode가 초기값 "pc"로 남는다.
// → redux mode 와 window.innerWidth(<=768, uiSlice의 0.4×1920 기준과 동일 폭)
//   를 OR로 함께 보고, 자체 리스너로 회전/리사이즈에도 갱신한다.
const MOBILE_MAX_WIDTH = 768;

const useIsMobile = () => {
  const { mode } = useSelector((state) => state.ui);
  const [narrow, setNarrow] = useState(
    typeof window !== "undefined" && window.innerWidth <= MOBILE_MAX_WIDTH
  );

  useEffect(() => {
    const update = () => setNarrow(window.innerWidth <= MOBILE_MAX_WIDTH);
    window.addEventListener("resize", update);
    window.addEventListener("orientationchange", update);
    return () => {
      window.removeEventListener("resize", update);
      window.removeEventListener("orientationchange", update);
    };
  }, []);

  return mode === "mobile" || narrow;
};

export default useIsMobile;
